<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
const props = defineProps<{
  context: FormKitFrameworkContext
}>()

const insideBox = inject('insideBox', true)

const label = computed(() => {
  const value = props.context.label as any
  return value instanceof Function ? value(props.context._value) : value
})

const onRemove = (...e) => {
  props.context.node.emit('remove', props.context.id)
}
</script>

<template>
  <FormDisclosure
    v-if="props.context.attrs.props?.type === 'disclosure'"
    :opened="!!context.attrs?.props?.opened || !context.state.valid"
    :standalone="!insideBox"
    :lazy="!!props.context.attrs.props.lazy"
    :class="{
      'border-4 border-solid border-red-500 rounded-lg p-4':
        !context.state.valid,
    }"
    @remove="onRemove"
  >
    <template #button>
      <div class="flex items-center space-x-2">
        <span v-if="label" class="font-medium">{{ label }}</span>
        <span v-else class="font-medium text-gray-400">{{
          context.label || 'New item'
        }}</span>
        <div
          v-if="context.state.dirty && !context.state.valid"
          class="i-heroicons-outline-exclamation-circle ml-2 text-red-500"
        />
      </div>
    </template>
    <div class="grid gap-3">
      <slot />
    </div>
  </FormDisclosure>
  <div v-else class="flex">
    <div class="flex-1">
      <slot />
    </div>
    <div class="flex items-center pl-1">
      <Button
        v-tooltip.top="{
          value: `This button removes item from list. You need to submit changes using 'SAVE' button`,
          pt: {
            arrow: {
              style: {
                borderBottomColor: 'var(--primary-color)',
              },
            },
            text: 'bg-primary text-[10px] text-center font-medium',
          },
          showDelay: 800,
          hideDelay: 300,
        }"
        variant="simple"
        class="text-gray-400 hover:text-red-800 hover:bg-red-100"
        @click.stop="onRemove"
      >
        <div class="i-heroicons-outline-trash" />
      </Button>
    </div>
  </div>
</template>
